import { cn } from "@/lib/utils";

interface LinkArrowIconProps {
  className?: string;
}

/** Figma link-arrow: горизонтальная линия со стрелкой, 16×15px. */
export function LinkArrowIcon({ className }: LinkArrowIconProps) {
  return (
    <svg
      className={cn("h-[15px] w-4 shrink-0", className)}
      viewBox="0 0 17 14.7279"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M16.7071 8.07107C17.0976 7.68054 17.0976 7.04738 16.7071 6.65685L10.3431 0.292893C9.95262 -0.097631 9.31946 -0.097631 8.92893 0.292893C8.53841 0.683418 8.53841 1.31658 8.92893 1.70711L14.5858 7.36396L8.92893 13.0208C8.53841 13.4113 8.53841 14.0445 8.92893 14.435C9.31946 14.8256 9.95262 14.8256 10.3431 14.435L16.7071 8.07107ZM0 7.36396V8.36396H16V7.36396V6.36396H0V7.36396Z"
        fill="currentColor"
      />
    </svg>
  );
}
